
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useDomicilioFiscal = () => {

    // variables
    const setToast = useEmpleadoStore( state => state.setToast )
    const objLogueado = useEmpleadoStore( state => state.objLogueado )
    const formInicial = {
        codigo_postal: '',
        codigo_fiscal: '',
        tipo_vialidad: '',
        nombre_vialidad: '',
        numero_exterior: '',
        numero_interior: '',
        nombre_colonia:'',
        nombre_localidad:'',
        municipio:''
    }
    const { URL } = url()
    const [formDomicilioFiscal, setFormDomicilioFiscal] = useState( formInicial )
    const [cargando, setCargando] = useState( false )


    // funciones
    const traerDomicilio = () => {

        if ( !objLogueado.email ) return

        var fd = new FormData()
        fd.append("funcion", "traerDomicilioFiscal")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setFormDomicilioFiscal({})
            e && setFormDomicilioFiscal(e)
        })
        .catch( a => {
            setToast( true )
            // alert("Error al traer los datos de tu domicilio. Puedes revisar tu conexión o iniciar sesión nuevamente.")
        });
    }


    const guardarDomicilio = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formDomicilioFiscal, funcion: 'guardarDomicilioFiscal', email: objLogueado.email })
        })
        .then( res => res.json() )
        .then( function (d) {
            elToast( d.mensaje )
        })
        .catch( a => alert("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.") )
        .finally( () => setCargando( false ) )
    }

    // useEffects
    useEffect(() => {
        traerDomicilio()
        // eslint-disable-next-line
    }, [])


    return {
        guardarDomicilio, setFormDomicilioFiscal, formDomicilioFiscal, cargando
    }
}

export default useDomicilioFiscal
